module.exports = __webpack_public_path__ + "static/media/chat2.bacecd98.svg";